var map = {
	"./27_BF5_cry_wolf.jpg": "8df3",
	"./64_M6_beetles.jpg": "f392",
	"./78_powerToThePorous.jpg": "a5e3",
	"./80_rememberTheAlbedo.jpg": "2e0f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc50";